import React from "react";
import { useNavigate } from "react-router-dom";
import ColorModeToggle from "./components/ColorModeToggle";

export default function LandingPage() {
  const navigate = useNavigate();

  return (
    <div className="landing-page">
      <div className="landing-toggle">
        <ColorModeToggle />
      </div>
      <main className="landing-main">
        <p className="landing-eyebrow">Clwb Nawa</p>
        <h1 className="landing-wordmark">Nawa Hub</h1>
        <hr className="landing-rule" />
        <p className="landing-tagline">
          A reference library for Japanese rope bondage techniques
        </p>
        <div className="landing-cta-row">
          <button
            className="landing-cta-primary"
            onClick={() => navigate("/login")}
          >
            Sign in
          </button>
          <button
            className="landing-cta-secondary"
            onClick={() => navigate("/login")}
          >
            Register
          </button>
        </div>
      </main>
    </div>
  );
}
